import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { add as addPerson } from '../../Actions/Person.action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Input from '../Inputs/Input';
import RadioButton from '../Inputs/Radiobutton';
import { EditorStringModel } from '../../Types/EditorString';
import EditorString from '../EditorString/EditorString';

const MyPagesAddUser = ({
  description,
}: {
  description?: EditorStringModel;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // FORM-VALUES
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('');

  const submitForm = () => {
    dispatch(
      addPerson({
        firstName,
        lastName,
        email,
        phone,
        role,
      })
    );
    navigate(-1);
  };

  return (
    <div className="col-span-2">
      <h1 className="mb-2">{translate('mypage.person.adduser')}</h1>
      {description && (
        <div className="mb-4 max-w-3xl text-base lg:mb-6">
          <EditorString value={description.value} />
        </div>
      )}
      <form className="flex flex-col">
        <Input
          inputSize="large"
          label={translate('mypage.person.firstname')}
          wrapperClassName="mb-4 [&_.input]:text-base"
          onChange={(e) => setFirstName(e.target.value)}
          placeholder={translate('general.placeholder.firstname')}
          type="text"
          id="fname"
        />
        <Input
          inputSize="large"
          label={translate('mypage.person.lastname')}
          wrapperClassName="mb-4 [&_.input]:text-base"
          onChange={(e) => setLastName(e.target.value)}
          placeholder={translate('general.placeholder.lastname')}
          type="text"
          id="lname"
        />
        <Input
          inputSize="large"
          label={translate('mypage.person.email')}
          wrapperClassName="mb-4 [&_.input]:text-base"
          onChange={(e) => setEmail(e.target.value)}
          placeholder={translate('general.placeholder.email')}
          type="email"
          id="email"
        />
        <Input
          inputSize="large"
          label={translate('mypage.person.phone')}
          wrapperClassName="mb-4 [&_.input]:text-base"
          onChange={(e) => setPhone(e.target.value)}
          placeholder={translate('general.placeholder.phone')}
          type="tel"
          id="tel"
        />
        <div className="flex flex-col gap-4 pb-6 pt-2 lg:pb-8 lg:pt-4">
          <RadioButton
            name="role-radio"
            inputSize="large"
            label="Admin"
            value="Admin"
            id="role1"
            onChange={(e) => setRole(e.target.value)}
            wrapperClassName="text-base flex gap-2"
          />
          <RadioButton
            name="role-radio"
            inputSize="large"
            label="OrderPlacer"
            value="OrderPlacer"
            id="role2"
            onChange={(e) => setRole(e.target.value)}
            wrapperClassName="text-base flex gap-2"
          />
          <RadioButton
            name="role-radio"
            inputSize="large"
            label="OrderApprover"
            value="OrderApprover"
            id="role3"
            onChange={(e) => setRole(e.target.value)}
            wrapperClassName="text-base flex gap-2"
          />
        </div>
      </form>
      <div className="flex gap-2">
        <button
          className="btn btn--primary btn--large"
          onClick={() => submitForm()}
        >
          {translate('general.save')}
        </button>
        <button
          className="btn btn--clear btn--large"
          onClick={() => navigate(-1)}
        >
          {translate('general.cancel')}
        </button>
      </div>
    </div>
  );
};

export default MyPagesAddUser;
